import templateUrl from 'emun.on-demand/admin/od-product-producer.htm'
import productConfig from 'emun.on-demand/admin/_config'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import Design from 'emun.on-demand/lib/design'
import Media from 'webutils/media/media'
import config from 'emun.on-demand/templates/_config'
import labels from 'emun.on-demand/templates/_labels'
import ProductTemplate from 'emun.on-demand/lib/product-template'
import AutoQuery from 'servicestack/auto-query/auto-query'
import modals from 'webmodals/modals'

let hasValue = m => !!m;

class ProductProducerController {
    constructor($state, $stateParams) {
        basicController(this)
        const $ctrl = this;
        let criteria = Object.assign({ active: true }, $stateParams);
        Object.assign($ctrl, { $state, $stateParams }, $stateParams, config, labels);
        $ctrl.panelType = 'default';
        $ctrl.maxShownSelections = 36;

        let options = Object.assign({
            url: 'QueryProductTemplates.json',
            tagTotalsUrl: 'QueryProductTemplateTagTotals.json?',
            orderBy: '-CreatedOn,Id',
            autoLoad: true,
            append: false,
            navs: [],
            pageSize: config.pageSize,
            filters: config.filters,
            sortOptions: config.sortOptions,
            criteria,
            scrub(response) {
                response.data.results = response.data.results.map(r => new ProductTemplate(r));
            },
            afterLoaded() {
                $ctrl.analyze();
            }
        }, config);

        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
        $ctrl.selectedProductTemplates = {};
        $ctrl.busy = 'Loading';
        let url = $ctrl.designId ? `QueryMedia/${$ctrl.designId}.json` : $ctrl.designEuid ? `QueryMedia/euid/${$ctrl.designEuid}.json` : null;
        //url += '?Fields=Id,Euid,Label,Tags,CreatedOn,Description,Height,Width,CreatedBy';
        let $design = $ctrl.bus.send(url).then(
            res => {
                $ctrl.busy = false;
                $ctrl.design = new Design(res.data.results[0], false);
            },
            e => { $ctrl.busy = 'Design not found'; }
        );
    }

    $onInit() {
        const $ctrl = this;
        //$ctrl.select($ctrl.tagKinds[0]);
    }

    $onDestroy() {
        const $ctrl = this;
        $ctrl.bus.dispose();
    }

    select(pt) {
        const $ctrl = this;
        if ($ctrl.selectedProductTemplates[pt.id])
            delete $ctrl.selectedProductTemplates[pt.id];
        else
            $ctrl.selectedProductTemplates[pt.id] = pt;
        $ctrl.analyze();
    }

    analyze() {
        const $ctrl = this;
        $ctrl.selectedLength = Object.keys($ctrl.selectedProductTemplates).length;
        $ctrl.all = ($ctrl.selectedLength >= $ctrl.query.total);
        $ctrl.any = ($ctrl.selectedLength > 0);
        $ctrl.none = ($ctrl.selectedLength === 0);
        $ctrl.selected = Object.values($ctrl.selectedProductTemplates).slice(0, $ctrl.maxShownSelections);
    }

    selectAll(g) {
        const $ctrl = this;
        let criteria = {
            ...$ctrl.query.getRequest(),
            skip: 0,
            take: $ctrl.query.total,
            tagCriteria: $ctrl.query.getTagCriteria()
        };
        $ctrl.bus.read($ctrl.query.url, criteria).then(res => {
            res.data.results.forEach(pt => $ctrl.selectedProductTemplates[pt.id] = pt);
            $ctrl.analyze();
        });
    }

    clearAll(g) {
        const $ctrl = this;
        $ctrl.selectedProductTemplates = {};
        $ctrl.analyze();
    }

    publish() {
        let $ctrl = this;
        $ctrl.busy = 'Distributing design';
        const request = {
            designId: $ctrl.design.id,
            productTemplateIds: Object.keys($ctrl.selectedProductTemplates)//.map(parseInt)
        };

        return $ctrl.bus.send('CreateProductDesigns.json', request)
            .then(res => $ctrl.onPublsihed(res), res => $ctrl.onPublishedFailed(res));
    }

    onPublsihed(res) {
        let $ctrl = this;
        $ctrl.$state.transitionTo("od-products.multi-view.grid", { designId: $ctrl.designId, recent: 5, context: 'publish' });
        $ctrl.onPublish();
    }

    onPublishedFailed(res) {
        let $ctrl = this;
        $ctrl.busy = 'could not create products';
        console.error($ctrl.busy, res);
    }
}

let ProductProducerComponent = {
    bindings: {
        designId: '@',
        onPublish: '&',
        onSaved: '&'
    },
    controller: ProductProducerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ProductProducerComponent;